import './PageIntro.scss';

import classNames from 'classnames';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';

import type { PageIntroProps } from './PageIntro.types';

export const PageIntro = ({ title, description, breadcrumbs, className }: PageIntroProps) => (
  <div className={classNames('page-intro', className)}>
    {breadcrumbs && breadcrumbs.length > 0 && (
      <nav className='page-intro__breadcrumb mb-4' aria-label='Breadcrumb'>
        <Breadcrumb listProps={{ className: 'mb-0' }}>
          {breadcrumbs.map((item, index) =>
            item.to ? (
              <Breadcrumb.Item key={`${item.label}-${index}`} linkAs={Link} linkProps={{ to: item.to }}>
                {item.label}
              </Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item key={`${item.label}-${index}`} active>
                {item.label}
              </Breadcrumb.Item>
            ),
          )}
        </Breadcrumb>
      </nav>
    )}
    <h1 className='text-primary mb-3'>{title}</h1>
    {description && <p className='text-secondary mb-0'>{description}</p>}
  </div>
);
